import React from 'react';
import PropTypes from 'prop-types';
import XLSX from 'xlsx/xlsx';
import Button from 'components/button';
import styles from './styles.css';

export default class AttendeeExportData extends React.Component {
    static propTypes = {
        attendees: PropTypes.array,
        orderId: PropTypes.string,
    };

    state = {}

    handleExport() {
        this.setState({loading: true});
        const attendeeData = this.props.attendees.map(attendee => ({
            Nombre: attendee.firstName,
            Apellido: attendee.lastName,
            'Razon social': attendee.legalName,
            CUIT: attendee.cuit,
        }));
        const attendeeDataJson = JSON.parse(JSON.stringify(attendeeData));
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(attendeeDataJson);

        XLSX.utils.book_append_sheet(wb, ws, 'invitados');
        XLSX.writeFile(wb, `invitados_orden_${this.props.orderId}.xlsx`);
        this.setState({loading: false});
    }

    render() {
        return (
            <div className={styles.root}>
                <Button onClick={() => this.handleExport()} theme='yellow' disabled={this.state.loading}>
                    {this.state.loading ? 'EXPORTANDO...' : 'EXPORTAR A EXCEL'}
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-detail/attendee-export/index.js